import React from "react";
import { connect } from "react-redux";

import { f_ObtenerRepartos, f_ObtenerRecoleccionesUnidad, f_ObtenerTotalesRecolecciones, f_ObtenerRecoleccionesDetalle, closeMessages } from "../../../store/actions/monitoreoActions";
import { logout } from "../../../store/actions/authActions";

import MonitoreoMapa from "./MonitoreoMapa.js";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import Spinner from "components/Spinner/Spinner.js";

//Iconos
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Tooltip from '@material-ui/core/Tooltip';

// import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

// import CircleBar from "components/CircleBar/CircleBar.js";

import {
    CircularProgressbar
  } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const useStyles = makeStyles(styles);

// function BootstrapTooltip(props) {
//     const classes = useStylesBootstrap();

//     return <Tooltip arrow classes={classes} {...props} />;
// }

function MonitoreoForm(props){
    const [formData, setFormData] = React.useState(null);

    const [ sucursal ] = React.useState(props.Sucursal);
    const [ fecha ] = React.useState(props.Fecha);

    const [totalRepartos, setTotalRepartos] = React.useState(0);
    const [totalGuias, setTotalGuias] = React.useState(0);
    const [totalEntregadas, setTotalEntregadas] = React.useState(0);
    const [totalDevueltas, setTotalDevueltas] = React.useState(0);
    const [totalPendientes, setTotalPendientes] = React.useState(0);
    const [cantEntregadas, setCantEntregadas] = React.useState(0);
    const [cantDevueltas, setCantDevueltas] = React.useState(0);
    const [cantPendientes, setCantPendientes] = React.useState(0);
    const [totalEnCurso, setTotalEnCurso] = React.useState(0);
    const [totalEnSucursal, setTotalEnSucursal] = React.useState(0);
    const [mostrarMapa, setmostrarMapa] = React.useState(false);

    const [, setFolioReparto] = React.useState(0);
    const [, setIdReparto] = React.useState(0);
    const [unidad, setUnidad] = React.useState(0);

    const classes = useStyles();

    
    React.useEffect(() => {
        props.scrollToTop();
     if(sucursal > 0){
        props.f_ObtenerRepartos(sucursal,fecha);
        props.f_ObtenerRecoleccionesUnidad(sucursal,fecha);
        props.f_ObtenerTotalesRecolecciones(sucursal,fecha);
        props.f_ObtenerRecoleccionesDetalle(sucursal,fecha);
     }
    }, []);

    // if data changes then set to the state the new values
  React.useEffect(() => {
    setFormData(props.repartosData);
    if(props.repartosData && props.repartosData.resultado && props.repartosData.resultado.totales){
        // console.log(formData);
        setTotalRepartos(props.repartosData.resultado.repartos.length);
        setTotalGuias(props.repartosData.resultado.totales.TotalGuias);
        setTotalEnCurso(props.repartosData.resultado.totales.TotalLiqudados);

        setTotalEntregadas(props.repartosData.resultado.totales.Entregadas);
        setTotalDevueltas(props.repartosData.resultado.totales.Devueltas);
        setTotalPendientes(props.repartosData.resultado.totales.Pendientes);
        
        setCantEntregadas("Total Entregadas: " + props.repartosData.resultado.totales.CantEntregadas);
        setCantDevueltas("Total Devueltas: " + props.repartosData.resultado.totales.CantDevueltas);
        setCantPendientes("Pendientes: " + props.repartosData.resultado.totales.CantPendientes);

        setTotalEnSucursal(props.repartosData.resultado.totales.EnSucursal);
    }
  }, [props.repartosData]);

  const scrollToTop = () => {
    props.scrollToTop(); 
  }

  const handleMostrar = (div,ocultar,mostrar) =>{
    document.getElementById(div).style.display = "";
    document.getElementById(ocultar).style.display = "none";
    document.getElementById(mostrar).style.display = "";
  }

  const handleOcultar = (div,mostrar,ocultar) =>{
    document.getElementById(div).style.display = "none";
    document.getElementById(ocultar).style.display = "none";
    document.getElementById(mostrar).style.display = "";
  }

  // Recolecciones por unidad (mismo económico que pinta el reparto), normalizadas
  // para casar el texto libre de recoleccion.unidad con f_Unidad().
  const normalizarUnidad = (unidad) => String(unidad).trim().toUpperCase().replace(/\s+/g, " ");

  const recoleccionesPorUnidad = {};
  if (props.recoleccionesData && props.recoleccionesData.resultado) {
    props.recoleccionesData.resultado.forEach((recol) => {
        recoleccionesPorUnidad[normalizarUnidad(recol.unidad)] = recol;
    });
  }

  // Totales del día para la card de cabecera y listado para el detalle expandible;
  // ambos degradan en silencio si su fetch falló (misma política que los círculos).
  const recolTotales = (props.recoleccionesTotalesData && props.recoleccionesTotalesData.resultado) || {};
  // transmitidas = ya asignadas a una unidad (estado TRANSMITIDO); no_transmitidas =
  // capturadas para la sucursal pero aun sin transmitir. El API las separo (antes venian
  // sumadas en transmitidas); el total del dia sigue siendo la suma de los cuatro estados.
  const totalRecolecciones = Number(recolTotales.transmitidas || 0) + Number(recolTotales.no_transmitidas || 0) + Number(recolTotales.realizadas || 0) + Number(recolTotales.canceladas || 0);
  const recoleccionesDetalle = (props.recoleccionesDetalleData && props.recoleccionesDetalleData.resultado) || [];

  const colorEstadoRecoleccion = (estado) => {
    if (estado === "REALIZADO") return "#4caf50";
    if (estado === "CANCELADO") return "#b20000";
    return "#ff9800";
  };

  const detalleRecoleccionesUnidad = (unidad) => (
    recoleccionesDetalle
        .filter((r) => normalizarUnidad(r.unidad) === normalizarUnidad(unidad))
        .map((r, index) => {
            return <div key={`rec_${index}`} style={{float:"left", width:"100%"}}>
                <div style={{float:"left", width:"200px"}}>
                    <h6>Recolección #<label style={{ color:"#000" }}>{r.folio}</label></h6>
                </div>
                <div style={{float:"left", width:"400px"}}>
                    <h6>Cliente:&nbsp;<label style={{ color:"#000", fontSize:"14px" }}>{r.cliente}</label></h6>
                </div>
                <div style={{float:"left"}}>
                    <h6>Estado:&nbsp;<label style={{ color: colorEstadoRecoleccion(r.estado), fontSize:"14px" }}>{r.estado}</label></h6>
                </div>
            </div>
        })
  );

  const bloqueRecolecciones = (recol) => (
    <React.Fragment>
        <div style={{float:"left", width:"120px", borderLeft:"1px solid #ccc"}}>
            <div style={{ marginLeft:"40px", width:"56px", height:"56px" }}>
                <CircularProgressbar
                        value={recol.porcentaje}
                        text={`${recol.porcentaje}%`}
                        strokeWidth={8}
                    />
            </div>
        </div>
        <div style={{float:"left", width:"280px"}}>
            <h6 style={{ textTransform:"lowercase" }}>{recol.recolectadas} recolectadas | {recol.fallidas} fallidas</h6>
            <label>{recol.pendientes} Pendientes</label>
        </div>
    </React.Fragment>
  );

  // Apertura de ruta por folio y ultima entrega del dia. El API manda
  // 'YYYY-MM-DD HH:mm:ss' o null (por unidad: la apertura MAS temprana de sus
  // folios y la entrega mas tardia; por folio en el detalle: las suyas).
  // apertura_disponible === false => falta la columna en la BD (DDL del API
  // EAD sin aplicar): se dice tal cual, no se confunde con "sin apertura".
  const aperturaDisponible = !(props.repartosData && props.repartosData.resultado
      && props.repartosData.resultado.apertura_disponible === false);
  const fechaHora = (valor) => {
    if (!valor) return null;
    const m = moment(valor, "YYYY-MM-DD HH:mm:ss", true);
    return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : String(valor);
  };
  const spanTiempo = (etiqueta, valor, vacio) => (
    <span style={{ display:"block", fontSize:"12px", lineHeight:"16px", color:"#555" }}>
        {etiqueta}:&nbsp;<label style={{ color: valor ? "#000" : "#999", fontSize:"12px" }}>{fechaHora(valor) || vacio}</label>
    </span>
  );
  const textoSinApertura = aperturaDisponible ? "sin apertura" : "no disponible (falta columna en BD)";

  const cards = (props.repartosData == null || !props.repartosData.resultado) ? [] : (
        props.repartosData.resultado.repartos.map((prop, key) => {
            let guiasTot = parseFloat(prop.totalguias);
            let entreTot = parseFloat(prop.totalentregadas);
            let devueTot = parseFloat(prop.totaldevueltas);
            let pendiTot = parseFloat(guiasTot - (entreTot + devueTot));
            let recol = recoleccionesPorUnidad[normalizarUnidad(prop.unidad)];
            //let percentage = ((entreTot + devueTot) / guiasTot) * 100;

            return [ 
                    <Card key = { key }>
                        <CardBody>                            
                                <div style={{float:"left", width:"100px", textAlign:"center"}}>
                                    <Tooltip title="MOSTRAR DETALLE" placement="top">
                                        <ExpandMoreIcon id={`exp_${key}`} style={{ fontSize: 40, marginTop:10 }} onClick={()=>{
                                            handleMostrar("div_"+key,"exp_"+key,"les_"+key);
                                        }}/>
                                    </Tooltip>
                                    <ExpandLessIcon id={`les_${key}`} style={{ fontSize: 40, marginTop:10, display:"none" }} onClick={()=>{
                                        handleOcultar("div_"+key,"exp_"+key,"les_"+key);
                                    }}/>
                                </div>
                                <div key = { key } style={{cursor:"pointer"}} onClick={()=>{
                                    handleRutaClick(prop.id, prop.folio,prop.unidad);
                                }}>
                                    <div style={{float:"left", width:"200px"}}>
                                        <h6>UNIDAD</h6>
                                        <label>{prop.unidad}</label>
                                    </div>
                                    <div style={{float:"left", width:"200px"}}>
                                        <h6>{prop.conductor}</h6>
                                        { spanTiempo("Apertura", prop.fecha_apertura, textoSinApertura) }
                                        { spanTiempo("Última entrega", prop.ultima_entrega, "sin entregas") }
                                    </div>
                                    <div style={{float:"left", width:"80px"}}>
                                        <div style={{ width:"70%", height: "70%" }}>
                                            <CircularProgressbar 
                                                    value={prop.porcentaje}
                                                    text={`${prop.porcentaje}%`}
                                                    strokeWidth={8}
                                                />
                                        </div>
                                    </div>
                                    <div style={{float:"left", width:"300px"}}>
                                        <h6 style={{ textTransform:"lowercase" }}>{entreTot} entregados | {devueTot} entregas fallidas</h6>
                                        <label>{ pendiTot } Pendientes</label>
                                    </div>
                                    <div style={{float:"left"}}>
                                        <h6>{ parseFloat(prop.liquidado) > 0 ? "Cerrado" : "En curso" }</h6>
                                    </div>
                                </div>
                                { !recol ? null : bloqueRecolecciones(recol) }
                        </CardBody>
                        <CardBody id={`div_${key}`} key = { key } style={{ display:"none", cursor:"pointer" }}>
                        {
                            props.repartosData.resultado.detallerepartos.map((data,index)=>{
                                if(data.unidad == prop.unidad){
                                    return <div key={index} style={{float:"left", width:"100%"}}> 
                                        <div style={{float:"left", width:"200px"}}>
                                            <h6>Ruta #<label style={{ color:"#000" }}>{data.folio}</label></h6>
                                        </div>
                                        <div style={{float:"left", width:"200px"}}>
                                            <h6>Total Guías:&nbsp;<label style={{ color:"#000", fontSize:"14px" }}>{data.totalguias}</label></h6>
                                        </div>
                                        <div style={{float:"left", width:"200px"}}>
                                            <h6>Entregadas:&nbsp;<label style={{ color:"#4caf50", fontSize:"14px" }}>{data.totalentregadas}</label></h6>
                                        </div>
                                        <div style={{float:"left", width:"200px"}}>
                                            <h6>Fallidas:&nbsp;<label style={{ color:"#b20000", fontSize:"14px" }}>{data.totaldevueltas}</label></h6>
                                        </div>
                                        <div style={{float:"left"}}>
                                            { spanTiempo("Apertura", data.fecha_apertura, textoSinApertura) }
                                            { spanTiempo("Última entrega", data.ultima_entrega, "sin entregas") }
                                        </div>
                                    </div>
                                }
                            })
                        }
                        { detalleRecoleccionesUnidad(prop.unidad) }
                        </CardBody>
                    </Card>
                // </div>
            ]
        })
    );

    // Unidades con recolecciones pero SIN reparto ese día: fila extra al final
    // (sin chevron ni click al mapa — no hay reparto que detallar).
    const unidadesConReparto = {};
    if (props.repartosData && props.repartosData.resultado) {
        props.repartosData.resultado.repartos.forEach((prop) => {
            unidadesConReparto[normalizarUnidad(prop.unidad)] = true;
        });
    }

    const cardsSinReparto = (props.recoleccionesData == null || !props.recoleccionesData.resultado) ? [] : (
        props.recoleccionesData.resultado
            .filter((recol) => !unidadesConReparto[normalizarUnidad(recol.unidad)])
            .map((recol, key) => {
                return [
                    <Card key = { `sinreparto_${key}` }>
                        <CardBody>
                                <div style={{float:"left", width:"100px", textAlign:"center"}}>
                                    <Tooltip title="MOSTRAR RECOLECCIONES" placement="top">
                                        <ExpandMoreIcon id={`sr_exp_${key}`} style={{ fontSize: 40, marginTop:10 }} onClick={()=>{
                                            handleMostrar("sr_div_"+key,"sr_exp_"+key,"sr_les_"+key);
                                        }}/>
                                    </Tooltip>
                                    <ExpandLessIcon id={`sr_les_${key}`} style={{ fontSize: 40, marginTop:10, display:"none" }} onClick={()=>{
                                        handleOcultar("sr_div_"+key,"sr_exp_"+key,"sr_les_"+key);
                                    }}/>
                                </div>
                                <div style={{float:"left", width:"200px"}}>
                                    <h6>UNIDAD</h6>
                                    <label>{recol.unidad}</label>
                                </div>
                                <div style={{float:"left", width:"200px"}}>&nbsp;</div>
                                <div style={{float:"left", width:"80px"}}>&nbsp;</div>
                                <div style={{float:"left", width:"300px"}}>&nbsp;</div>
                                <div style={{float:"left"}}>
                                    <h6>Sin reparto</h6>
                                </div>
                                { bloqueRecolecciones(recol) }
                        </CardBody>
                        <CardBody id={`sr_div_${key}`} style={{ display:"none" }}>
                        { detalleRecoleccionesUnidad(recol.unidad) }
                        </CardBody>
                    </Card>
                ]
            })
    );

    const handleRutaClick = (id, reparto,unidad) => {
        // mostrarReparto(id, reparto);
        setIdReparto(id);
        setFolioReparto(reparto);
        setUnidad(unidad);
        setmostrarMapa(true);
    }

    const returnToRepartos = () => {
        props.scrollToTop();
        setmostrarMapa(false);
        props.f_ObtenerRepartos(sucursal,fecha);
        props.f_ObtenerRecoleccionesUnidad(sucursal,fecha);
        props.f_ObtenerTotalesRecolecciones(sucursal,fecha);
        props.f_ObtenerRecoleccionesDetalle(sucursal,fecha);
    }

    const returnToListadoSucursales = () => {        
        props.returnToList();
    }

    const hideAlert = () => { props.closeMessages(); };
    const handleLogOut = () => { props.closeMessages(); props.logout(); };

    let errorMessage = !props.MensajeError ? null : (
        <SweetAlert
          danger
          style={{ display: "block" }}
          title="Error!"
          onConfirm={() => props.MensajeError.indexOf("Acceso denegado")>-1 ? handleLogOut() : hideAlert()}
          onCancel={() => props.MensajeError.indexOf("Acceso denegado")>-1 ? handleLogOut() : hideAlert()}
          confirmBtnCssClass={classes.button + " " + classes.success}
        >
          {props.MensajeError}
        </SweetAlert>
      );

    const form = (!formData) ? ((<Spinner width={"80%"} height={5} color={"black"} loading />)) : <div>
        <GridContainer>
                <GridItem xs={12} sm={6} md={6} lg={2}>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <h6>Rutas</h6>
                            <label style={{fontSize:"22px", color:"#000"}}>{ totalRepartos }</label>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={2}>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <h6>En curso</h6>
                            <label style={{fontSize:"22px", color:"#000"}}>{ totalEnCurso }</label>
                        </CardBody>
                    </Card>
                </GridItem>
                {/* <GridItem xs={12} sm={6} md={6} lg={2}>
                    <Card>
                        <CardBody>
                            <section className="container">
                                <div style={{float:"left", width:"100px", textAlign:"center"}}>
                                    <h6>En curso</h6>
                                    <label style={{fontSize:"22px", color:"#000"}}>{ totalEnCurso }</label>
                                </div>
                                <div style={{float:"left", borderLeft :"1px solid #ccc", width:"80px"}}>
                                    <div style={{ marginLeft:"15px", width:"85%", height: "85%" }}>
                                        <CircularProgressbar 
                                            value={percentage}
                                            text={`${percentage}%`}
                                            strokeWidth={8}
                                        />
                                    </div>
                                </div>
                                <div style={{float:"left", textAlign:"right"}}>
                                    <div style={{marginLeft:"30px",  textAlign:"right"}}>
                                        <label style={{fontSize:"13px", color:"#000"}}>Demoradas</label>
                                        <label style={{marginLeft:"15px", fontSize:"13px", color:"#000"}}>100%</label><br></br>
                                        <label style={{fontSize:"13px", color:"#000"}}>a Tiempo</label>
                                        <label style={{marginLeft:"15px", fontSize:"13px", color:"#000"}}>100%</label>
                                    </div>
                                </div>
                            </section>
                            
                        </CardBody>
                    </Card>
                </GridItem> */}
                <GridItem xs={12} sm={6} md={6} lg={4}>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <section className="container">
                                <div style={{float:"left", width:"100px"}}>
                                    <h6>Guías</h6>
                                    <label style={{fontSize:"22px", color:"#000"}}>{ totalGuias }</label>
                                </div>
                                <div style={{float:"left", borderLeft :"1px solid #ccc"}}>
                                    <div style={{marginLeft:"30px",  textAlign:"right"}}>
                                        <Tooltip title={ cantEntregadas } placement="left-start">
                                            <label style={{fontSize:"13px", color:"#000"}}>Entregados</label>
                                        </Tooltip>
                                        <label style={{marginLeft:"15px", fontSize:"13px", color:"#000"}}>{ totalEntregadas }%</label><br></br>
                                        <Tooltip title={ cantDevueltas } placement="left-start">
                                            <label style={{fontSize:"13px", color:"#000"}}>Entregas Fallidas</label>
                                        </Tooltip>
                                        <label style={{marginLeft:"15px", fontSize:"13px", color:"#000"}}>{ totalDevueltas }%</label><br></br>
                                        <Tooltip title={ cantPendientes } placement="left-start">
                                            <label style={{fontSize:"13px", color:"#000"}}>Pendientes</label>
                                        </Tooltip>
                                        <label style={{marginLeft:"15px", fontSize:"13px", color:"#000"}}>{ totalPendientes }%</label>
                                    </div>
                                </div>
                            </section>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={2}>
                    <Card color="warning">
                        <CardBody style={{textAlign:'center'}}>
                            <h6>Guías Almacen Destino(EAD)</h6>
                            <label style={{fontSize:"22px", color:"#FFF"}}>{ totalEnSucursal }</label>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={6} md={6} lg={2}>
                    <Card>
                        <CardBody style={{textAlign:'center'}}>
                            <h6>Recolecciones</h6>
                            <label style={{fontSize:"22px", color:"#000"}}>{ totalRecolecciones }</label>
                            <div style={{marginTop:"5px"}}>
                                <label style={{fontSize:"12px", color:"#000"}}>Transmitidas: { Number(recolTotales.transmitidas || 0) }</label><br></br>
                                <label style={{fontSize:"12px", color:"#ff9800"}}>No Transmitidas: { Number(recolTotales.no_transmitidas || 0) }</label><br></br>
                                <label style={{fontSize:"12px", color:"#4caf50"}}>Realizadas: { Number(recolTotales.realizadas || 0) }</label><br></br>
                                <label style={{fontSize:"12px", color:"#b20000"}}>Canceladas: { Number(recolTotales.canceladas || 0) }</label>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12} lg={12}>
                    {
                        cards.map((prop) => {
                            return prop;
                        })
                    }
                    {
                        cardsSinReparto.map((prop) => {
                            return prop;
                        })
                    }
                </GridItem>
            </GridContainer>
            <div style={{ width:"100%",  textAlign:"center" }}>
                <Button
                    color="warning"
                    onClick={returnToListadoSucursales}
                    className={classes.registerButton}
                >
                    Regresar
                </Button>
            </div>
    </div>;

    // idReparto={idReparto} folioReparto={folioReparto}
    const mapa = <MonitoreoMapa unidad={unidad} fecha={fecha} sucursal={sucursal} returnToRepartos={returnToRepartos} scrollToTop={scrollToTop}></MonitoreoMapa>;

    return (
        <React.Fragment>
            { errorMessage }
            { mostrarMapa ? mapa : form }
        </React.Fragment>
      );
}

const mapStateToProps = (state) => {
    return {
        // "listData": state.catalogoCategorias.catalogoCategorias_List,
        // "listData_Error": state.catalogoCategorias.catalogoCategorias_List_Error,
        "repartosData": state.monitoreo.monitoreo_Data,
        "recoleccionesData": state.monitoreo.monitoreo_Recolecciones_Data,
        "recoleccionesTotalesData": state.monitoreo.monitoreo_Recolecciones_Totales,
        "recoleccionesDetalleData": state.monitoreo.monitoreo_Recolecciones_Detalle,
        "MensajeError": state.monitoreo.monitoreo_Error_Message,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // "getListForTable": () => dispatch(getListForTable()),
        "f_ObtenerRepartos": (sucursal, fecha) => dispatch(f_ObtenerRepartos(sucursal, fecha)),
        "f_ObtenerRecoleccionesUnidad": (sucursal, fecha) => dispatch(f_ObtenerRecoleccionesUnidad(sucursal, fecha)),
        "f_ObtenerTotalesRecolecciones": (sucursal, fecha) => dispatch(f_ObtenerTotalesRecolecciones(sucursal, fecha)),
        "f_ObtenerRecoleccionesDetalle": (sucursal, fecha) => dispatch(f_ObtenerRecoleccionesDetalle(sucursal, fecha)),
        "closeMessages": () => dispatch(closeMessages()),
        "logout": () => dispatch(logout()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonitoreoForm);
// export default MonitoreoForm;